import { render, staticRenderFns } from "./beanRules.vue?vue&type=template&id=3a241166&scoped=true"
import script from "./beanRules.vue?vue&type=script&lang=js"
export * from "./beanRules.vue?vue&type=script&lang=js"
import style0 from "./beanRules.vue?vue&type=style&index=0&id=3a241166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a241166",
  null
  
)

export default component.exports